import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/CommonUtils";

const metricProcessName = "SCC_PACKAGE_SEARCH";
export async function getPackageHistoryForAssociate(associateLoginId, pageSize, pageToken = null, fromEpochMilli = null, toEpochMilli = null) {
    
    const requestBody = {
        "associateLoginId": associateLoginId,
        "pageSize": pageSize,
        "pageToken": pageToken,
        "startTime": fromEpochMilli,
        "endTime": toEpochMilli
    }
    const startTime = Date.now();

    const request = {
        resourcePath: "/os/getPackageHistoryForAssociate",
        httpMethod: "post",
        processName: "oculus",
        requestBody: requestBody
    }

    try {
        const response = await getAPIGatewayDataFromParent(request);
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getPackageHistoryForAssociate", true);
            return response.data;
        } else {
            logOperationalMetric(startTime, metricProcessName, "getPackageHistoryForAssociate", false);
            return {
                packageRecordList: [],
                nextPageToken: null
            };
        }
    } catch (error) {
        return {
            packageRecordList: [],
            nextPageToken: null
        }
    }
}


// WEBPACK FOOTER //
// ./src/commons/api/GetPackageHistoryForAssociateResults.js